
export const INIT_BUYCART = 'INIT_BUYCART'
export const RECORD_USERINFO = 'RECORD_USERINFO'
export const GET_USERINFO = 'GET_USERINFO'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js